import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Flex, Spin } from "antd";
import { AdminShell } from "./components/AdminShell";
import { LoginPage } from "./pages/LoginPage";

const DashboardPage = lazy(() =>
  import("./pages/DashboardPage").then((module) => ({
    default: module.DashboardPage,
  })),
);
const UsersPage = lazy(() =>
  import("./pages/UsersPage").then((module) => ({ default: module.UsersPage })),
);
const MarketPage = lazy(() =>
  import("./pages/MarketPage").then((module) => ({
    default: module.MarketPage,
  })),
);
const AlertPolicyPage = lazy(() =>
  import("./pages/AlertPolicyPage").then((module) => ({
    default: module.AlertPolicyPage,
  })),
);
const SystemPage = lazy(() =>
  import("./pages/SystemPage").then((module) => ({
    default: module.SystemPage,
  })),
);
const EventsPage = lazy(() =>
  import("./pages/EventsPage").then((module) => ({
    default: module.EventsPage,
  })),
);
const DevicesPage = lazy(() =>
  import("./pages/DevicesPage").then((module) => ({
    default: module.DevicesPage,
  })),
);
const SyncPage = lazy(() =>
  import("./pages/SyncPage").then((module) => ({ default: module.SyncPage })),
);
const AdminsPage = lazy(() =>
  import("./pages/AdminsPage").then((module) => ({
    default: module.AdminsPage,
  })),
);
const AuditPage = lazy(() =>
  import("./pages/AuditPage").then((module) => ({ default: module.AuditPage })),
);

export function RootApp() {
  return (
    <Suspense
      fallback={
        <Flex className="query-state" align="center" justify="center">
          <Spin size="large" />
        </Flex>
      }
    >
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<AdminShell />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/market" element={<MarketPage />} />
          <Route path="/alerts" element={<AlertPolicyPage />} />
          <Route path="/system" element={<SystemPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/devices" element={<DevicesPage />} />
          <Route path="/sync" element={<SyncPage />} />
          <Route path="/admins" element={<AdminsPage />} />
          <Route path="/audit" element={<AuditPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Suspense>
  );
}
